import types from '@/store/types/Sorteador'
import Vue from 'vue';

const actions = {
  [types.actions.SorteadorLoginOficial]:({commit})=>{
    return new Promise ((resolve,reject)=>{
      Vue.prototype.$http.post(`pajel/sorteador/login_oficial`).then(r => {
        resolve(r);
      });
    })
  },
  [types.actions.SorteadorLoginDemo]:({commit})=>{
    return new Promise ((resolve,reject)=>{
      Vue.prototype.$http.post(`pajel/sorteador/login_demo`).then(r => {
        resolve(r);
      });
    })
  },
}
export default {
  actions,
}
